<script setup lang="ts">
import { SearchCheckIcon } from 'lucide-vue-next'

const { t } = useI18n()
const router = useRouter()

const { data: complianceScore, isPending } = useComplianceScore()
const totalRequired = computed(() => complianceScore.value?.reduce((acc, curr) => acc + curr.totalRequired, 0) || 0)
const completedRequired = computed(() => complianceScore.value?.reduce((acc, curr) => acc + curr.completedRequired, 0) || 0)
</script>

<template>
  <Card v-if="!isPending" class="flex grow">
    <template #title>
      <div class="flex justify-between grow items-center">
        <div class="flex gap-2">
          <SearchCheckIcon :size="24" />
          {{ t('global.compliance_score') }}
        </div>
        <EButton
          class="btn-primary btn-outline"
          size="sm"
          @click="router.push('/compliances')"
        >
          {{ t('global.continue') }}
        </EButton>
      </div>
    </template>
    <template #content>
      <LightSubtitle :subtitle="t('global.compliance_score_desc')" />

      <div class="bg-base-200 p-4 rounded-lg flex flex-col gap-2 grow justify-center">
        <div v-if="totalRequired > 0">
          <div class="flex justify-between">
            <div class="text-base-content font-semibold">
              {{ t('global.compliance_score_progress', { progress: Math.round((completedRequired / totalRequired) * 100) }) }}
            </div>
            <div class="text-base-content/80 text-xs font-semibold">
              {{ t('global.compliance_score_progress_desc', { completed: completedRequired, total: totalRequired }) }}
            </div>
          </div>
          <progress
            class="progress progress-primary w-full"
            :value="completedRequired"
            :max="totalRequired"
          />
        </div>
        <div v-else class="text-base-content font-semibold">
          {{ t('global.no_compliance_score') }}
        </div>
      </div>
    </template>
  </Card>

  <div v-else class="skeleton h-full w-full" />
</template>
